import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getJson(str: string): any {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
}

export function isValidJson(str: string): boolean {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

// 정렬 옵션 설정
const collatorOptions: Intl.CollatorOptions = {
  numeric: true, // 숫자 정렬 활성화
  sensitivity: "base", // 비교 민감도 (base, accent, case, variant)
  // "base": 기본 문자만 비교 (a ≠ b, a = á, a = A)
  // "accent": 발음 구별 (a ≠ b, a ≠ á, a = A)
  // "case": 대소문자 구별 (a ≠ b, a = á, a ≠ A)
  // "variant": 모든 것을 구별 (a ≠ b, a ≠ á, a ≠ A)
  ignorePunctuation: true, // 구두점 무시
  caseFirst: "false", // 대소문자 우선순위 (false, upper, lower)
};

// 한글/영어 정렬을 위한 Collator 인스턴스 생성
export const collator = new Intl.Collator(["ko", "en"], collatorOptions);

export function compareName(nameA: string, nameB: string) {
  // 한글 여부 확인
  const isKoreanA = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(nameA);
  const isKoreanB = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(nameB);

  // 한글과 영어를 구분하여 정렬
  if (isKoreanA && !isKoreanB) return -1; // 한글이 먼저
  if (!isKoreanA && isKoreanB) return 1; // 영어는 나중에

  // 같은 언어끼리는 알파벳/가나다 순으로 정렬
  return collator.compare(nameA, nameB);
}

export const delay = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

export async function withRetry<T>(
  fn: () => Promise<T>,
  maxRetries: number,
  retryDelay: number,
  useExponentialBackoff: boolean,
): Promise<T> {
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await fn();
    } catch (error) {
      if (i === maxRetries - 1) throw error;
      const backoffDelay = useExponentialBackoff
        ? Math.pow(2, i) * retryDelay
        : retryDelay;
      await delay(backoffDelay);
    }
  }
  throw new Error("Retry failed"); // Typescript needs this for type safety
}
